import { CasinoMenuActionsBootstrapService, OnAppInitHandler } from '@casinocore/platform';
import {
    CasinoCoreGamelaunchService,
    CasinoLobbyService,
    CasinoManager,
    FavouriteService,
    GameLaunchUrlFormationService,
    OtherProductService,
} from '@casinocore/platform/core';

export const dynamicServicesMap = {
    lobbyService: CasinoLobbyService,
    otherProductService: OtherProductService,
    casinoManager: CasinoManager,
    casinoMenuActionsBootstrapService: CasinoMenuActionsBootstrapService,
    favouriteService: FavouriteService,
    onAppInitHandler: OnAppInitHandler,
    casinoCoreGamelaunchService: CasinoCoreGamelaunchService,
    gameLaunchUrlFormationService: GameLaunchUrlFormationService,
};
